<div class="row row-cols-sm-auto">
  <div class="col-12">TmwNumberRangeComponent</div>
</div>
